export default "__VITE_ASSET__c5c6056d__"